import { isSentrySuppressedReason } from "./error.js";
//#region src/report.ts
function reportToSentry(sentry, error, options = {}) {
	if (options.reason && isSentrySuppressedReason(options.reason)) return;
	const errorObj = error instanceof Error ? error : new Error(String(error));
	const level = options.level ?? "error";
	sentry.withScope((scope) => {
		scope.setLevel(level);
		if (options.tags) for (const [k, v] of Object.entries(options.tags)) scope.setTag(k, v);
		if (options.extra) scope.setExtras(options.extra);
		if (options.contexts) for (const [name, data] of Object.entries(options.contexts)) scope.setContext(name, data);
		if (options.fingerprint) scope.setFingerprint(options.fingerprint);
		sentry.captureException(errorObj);
	});
}
//#endregion
export { reportToSentry };

//# sourceMappingURL=report.js.map